﻿window.cDataSaisie = function (option) {
    var Me = this

    this.data = null
    this.dataTemplate = null
    this.lstObligatoire = []

    this.mClear = function () {
        this.dataTemplate = null
        this.data = {
            id_data_saisie: null,
            id_table: null,
            id: null,
            con_nom: "",
            con_prenom: "",
            //is_societe: "0",
            id_type_client: "0",
            nom_str: "",
            siret: "",
            tvaintra: "",
            adresse_email: "",
            adr_ad1: "",
            adr_ad2: "",
            adr_ad3: "",
            adr_cp: "",
            adr_ville: "",
            adr_cedex: "",
            adr_pays: "",
            adr_code_pays: "",
            adr_region: "",
            adr_dpt: "",
            adr_geo_latitude: null,
            adr_geo_longitude: null,
            adr_code_pays: "",
            adr_normalise: "",
            tel_sms: "",
            tel_complet: "",
            tel_error: null,
            tel_num_type: null,
            tel_number: "",
            tel_code_pays: ""
        }
    }
    this.mClear()

    this.mInitWithDataSaisie = function (dataSaisie) {
        this.mClear()
        this.data = dataSaisie
    }

    this.mInitWithDataTemplate = function (dataTemplate = null) {
        this.mClear()

        this.dataTemplate = dataTemplate
        if (this.dataTemplate) {
            this.data.con_nom = this.dataTemplate.con_nom ?? ""
            this.data.con_prenom = this.dataTemplate.con_prenom ?? ""
            this.data.adresse_email = this.dataTemplate.adresse_email ?? ""
            if (this.dataTemplate.id_champ_table_adresse) {
                this.data.adr_ad1 = this.dataTemplate.adr_ad1 ?? ""
                this.data.adr_ad2 = this.dataTemplate.adr_ad2 ?? ""
                this.data.adr_ad3 = this.dataTemplate.adr_ad3 ?? ""
                this.data.adr_cp = this.dataTemplate.adr_cp ?? ""
                this.data.adr_ville = this.dataTemplate.adr_ville ?? ""
                this.data.adr_cedex = this.dataTemplate.adr_cedex ?? ""
                this.data.adr_pays = this.dataTemplate.adr_pays ?? ""
                this.data.adr_region = this.dataTemplate.adr_region ?? ""
                this.data.adr_dpt = this.dataTemplate.adr_dpt ?? ""
                this.data.adr_geo_latitude = this.dataTemplate.adr_geo_latitude
                this.data.adr_geo_longitude = this.dataTemplate.adr_geo_longitude
                this.data.adr_code_pays = this.dataTemplate.adr_code_pays ?? ""
                this.data.adr_normalise = this.dataTemplate.adr_normalise
            }
            if (this.dataTemplate.mob_id_champ_table_tel != null) {
                this.data.tel_sms = this.dataTemplate.mob_sms ?? ""
                this.data.tel_complet = this.dataTemplate.mob_complet ?? ""
                this.data.tel_error = this.dataTemplate.mob_error
                this.data.tel_num_type = this.dataTemplate.mob_num_type
                this.data.tel_number = this.dataTemplate.mob_number ?? ""
                this.data.tel_code_pays = this.dataTemplate.mob_code_pays ?? ""
            } else if (this.dataTemplate.tel_id_champ_table_tel != null) {
                this.data.tel_sms = this.dataTemplate.tel_sms ?? ""
                this.data.tel_complet = this.dataTemplate.tel_complet ?? ""
                this.data.tel_error = this.dataTemplate.tel_error
                this.data.tel_num_type = this.dataTemplate.tel_num_type
                this.data.tel_number = this.dataTemplate.tel_number ?? ""
                this.data.tel_code_pays = this.dataTemplate.tel_code_pays ?? ""
            }
            if (this.dataTemplate.id_table == option.bddCtrl.table.mGetItemFromNom("structures").id_table ||
                this.dataTemplate.id_table == option.bddCtrl.table.mGetItemFromNom("structures_contact").id_table) {
                //on a une structure
                //this.data.is_societe = "1"
                this.data.nom_str = this.dataTemplate.nom_str ?? ""
                this.data.siret = this.dataTemplate.siret ?? ""
                this.data.tvaintra = this.dataTemplate.tvaintra ?? ""
                this.data.id_type_client = this.dataTemplate.id_type_client
            } else {
                //on a une structure
                //this.data.is_societe = "0"
                this.data.id_type_client = "0"
                this.data.nom_str = ""
                this.data.siret = ""
                this.data.tvaintra = ""
            }
        }
    }

    this.mInitWithDataDocCptClient = function (dataDocCptClient) {
        this.data = {
            id_data_saisie: null,
            id_table: dataDocCptClient.id_table,
            id: dataDocCptClient.id,
            con_nom: (dataDocCptClient.con_nom ? dataDocCptClient.con_nom : ""),
            con_prenom: (dataDocCptClient.con_prenom ? dataDocCptClient.con_prenom : ""),
            id_type_client: dataDocCptClient.id_type_client,
            //is_societe: ((dataDocCptClient.nom && dataDocCptClient.nom.length > 0) || (dataDocCptClient.siret && dataDocCptClient.siret.length > 0) || (dataDocCptClient.tva_intra && dataDocCptClient.tva_intra.length > 0) ? "1" : "0"),
            nom_str: (dataDocCptClient.nom ? dataDocCptClient.nom : ""),
            siret: (dataDocCptClient.siret ? dataDocCptClient.siret : ""),
            tvaintra: (dataDocCptClient.tva_intra ? dataDocCptClient.tva_intra : ""),
            adresse_email: (dataDocCptClient.adresse_email ? dataDocCptClient.adresse_email : ""),
            adr_ad1: (dataDocCptClient.ad1 ? dataDocCptClient.ad1 : ""),
            adr_ad2: (dataDocCptClient.ad2 ? dataDocCptClient.ad2 : ""),
            adr_ad3: (dataDocCptClient.ad3 ? dataDocCptClient.ad3 : ""),
            adr_cp: (dataDocCptClient.cp ? dataDocCptClient.cp : ""),
            adr_ville: (dataDocCptClient.ville ? dataDocCptClient.ville : ""),
            adr_cedex: (dataDocCptClient.cedex ? dataDocCptClient.cedex : ""),
            adr_pays: (dataDocCptClient.pays ? dataDocCptClient.pays : ""),
            adr_code_pays: (dataDocCptClient.code_pays ? dataDocCptClient.code_pays : ""),
            adr_region: "",
            adr_dpt: "",
            adr_geo_latitude: null,
            adr_geo_longitude: null,
            adr_normalise: "",
            tel_sms: "",
            tel_complet: "",
            tel_error: null,
            tel_num_type: null,
            tel_number: "",
            tel_code_pays: ""
        }
        if (dataDocCptClient.tel_sms && dataDocCptClient.tel_sms.length > 0) {
            this.data.tel_sms = dataDocCptClient.tel_sms
            this.data.tel_complet = dataDocCptClient.tel_complet
            this.data.tel_error = dataDocCptClient.tel_error
            this.data.tel_num_type = dataDocCptClient.tel_num_type
            this.data.tel_number = dataDocCptClient.tel_number
            this.data.tel_code_pays = dataDocCptClient.tel_code_pays
        } else if (dataDocCptClient.mob_sms && dataDocCptClient.mob_sms.length > 0) {
            this.data.tel_sms = dataDocCptClient.mob_sms
            this.data.tel_complet = dataDocCptClient.mob_complet
            this.data.tel_error = dataDocCptClient.mob_error
            this.data.tel_num_type = dataDocCptClient.mob_num_type
            this.data.tel_number = dataDocCptClient.mob_number
            this.data.tel_code_pays = dataDocCptClient.mob_code_pays
        }
    }

    this.mInitWithCompteClient = function (dataCptCli) {
        this.data = {
            con_nom: (dataCptCli.nom_contact ? dataCptCli.nom_contact : ""),
            con_prenom: (dataCptCli.prenom_contact ? dataCptCli.prenom_contact : ""),
            id_type_client: dataCptCli.id_type_client,
            //is_societe: ((dataCptCli.nom && dataCptCli.nom.length > 0) || (dataCptCli.siret && dataCptCli.siret.length > 0) || (dataCptCli.tva_intra && dataCptCli.tva_intra.length > 0) ? "1" : "0"),
            nom_str: (dataCptCli.nom ? dataCptCli.nom : ""),
            siret: (dataCptCli.siret ? dataCptCli.siret : ""),
            tvaintra: (dataCptCli.tva_intra ? dataCptCli.tva_intra : ""),
            adresse_email: (dataCptCli.adresse_email ? dataCptCli.adresse_email : ""),
            adr_ad1: (dataCptCli.ad1 ? dataCptCli.ad1 : ""),
            adr_ad2: "",
            adr_ad3: "",
            adr_cp: (dataCptCli.cp ? dataCptCli.cp : ""),
            adr_ville: (dataCptCli.ville ? dataCptCli.ville : ""),
            adr_cedex: "",
            adr_pays: (dataCptCli.pays ? dataCptCli.pays : ""),
            adr_code_pays: (dataCptCli.code_pays ? dataCptCli.code_pays : ""),
            adr_region: "",
            adr_dpt: "",
            adr_geo_latitude: null,
            adr_geo_longitude: null,
            adr_normalise: "",
            tel_sms: "",
            tel_complet: "",
            tel_error: null,
            tel_num_type: null,
            tel_number: "",
            tel_code_pays: ""
        }
        if (dataCptCli.tel_sms && dataCptCli.tel_sms.length > 0) {
            this.data.tel_sms = dataCptCli.tel_sms
            this.data.tel_complet = dataCptCli.tel_complet
            this.data.tel_error = dataCptCli.tel_error
            this.data.tel_num_type = dataCptCli.tel_num_type
            this.data.tel_number = dataCptCli.tel_number
            this.data.tel_code_pays = dataCptCli.tel_code_pays
        } else if (dataCptCli.mob_sms && dataCptCli.mob_sms.length > 0) {
            this.data.tel_sms = dataCptCli.mob_sms
            this.data.tel_complet = dataCptCli.mob_complet
            this.data.tel_error = dataCptCli.mob_error
            this.data.tel_num_type = dataCptCli.mob_num_type
            this.data.tel_number = dataCptCli.mob_number
            this.data.tel_code_pays = dataCptCli.mob_code_pays
        }
    }

    this.mInitWithAdresseEmail = function (adresseEmail, funcEnd) {
        option.bddCtrl.mAjaxCall({
            command: "getdataTemplatecontactfromemail",
            adresse_email: adresseEmail
        }, function (data) {
            if (typeof data.lstdatatemplate == 'undefined') data.lstdatatemplate = []
            if (data.lstdatatemplate.length > 0) {
                Me.mInitWithDataTemplate(data.lstdatatemplate[0])
                //Me.dataTemplate = data.lstdatatemplate[0]
                //Me.data = {
                //    adresse_email: adresseEmail,
                //    con_nom: Me.dataTemplate.con_nom,
                //    con_prenom: Me.dataTemplate.con_prenom,
                //    adr_ad1: Me.dataTemplate.adr_ad1,
                //    adr_ad2: Me.dataTemplate.adr_ad2,
                //    adr_ad2: Me.dataTemplate.adr_ad3,
                //    adr_cp: Me.dataTemplate.adr_cp,
                //    adr_ville: Me.dataTemplate.adr_ville,
                //    adr_dpt: Me.dataTemplate.adr_dpt,
                //    adr_region: Me.dataTemplate.adr_region,
                //    adr_pays: Me.dataTemplate.adr_pays,
                //    adr_geo_latitude: Me.dataTemplate.adr_geo_latitude,
                //    adr_geo_longitude: Me.dataTemplate.adr_geo_longitude,
                //    adr_code_pays: Me.dataTemplate.adr_code_pays
                //}
                //switch (option.bddCtrl.table.mGetItem(Me.dataTemplate.id_table).nom) {
                //    case "structures": case "structures_contact":
                //        Me.data.is_societe = "1"
                //        Me.data.nom_str = Me.dataTemplate.nom_str
                //        Me.data.siret = Me.dataTemplate.siret
                //        Me.data.tvaintra = Me.dataTemplate.tvaintra
                //        break;
                //    case "contact":
                //        Me.data.is_societe = "0"
                //        Me.data.nom_str = ""
                //        Me.data.siret = ""
                //        Me.data.tvaintra = ""
                //        break;
                //}
                //if (Me.dataTemplate) {
                //    if (Me.dataTemplate.mob_sms && Me.dataTemplate.mob_sms.length > 0) {
                //        Me.data.tel_code_pays = Me.dataTemplate.mob_code_pays
                //        Me.data.tel_number = Me.dataTemplate.mob_number
                //        Me.data.tel_complet = Me.dataTemplate.mob_complet
                //        Me.data.tel_sms = Me.dataTemplate.mob_sms
                //        Me.data.tel_error = Me.dataTemplate.mob_error
                //        Me.data.tel_num_type = Me.dataTemplate.mob_num_type
                //    } else if (Me.dataTemplate.tel_sms && Me.dataTemplate.tel_sms.length > 0) {
                //        Me.data.tel_code_pays = Me.dataTemplate.tel_code_pays
                //        Me.data.tel_number = Me.dataTemplate.tel_number
                //        Me.data.tel_complet = Me.dataTemplate.tel_complet
                //        Me.data.tel_sms = Me.dataTemplate.tel_sms
                //        Me.data.tel_error = Me.dataTemplate.tel_error
                //        Me.data.tel_num_type = Me.dataTemplate.tel_num_type
                //    }
                //}
            } else {
                Me.dataTemplate = null
                Me.data = {
                    adresse_email: adresseEmail,
                    id_type_client: "0"
                }
            }
            funcEnd()
        })
    }

    this.mSaveInDataTemplate = function (funcEnd,funcKo) {
        //option.bddCtrl.mAjaxCall({
        //    command: "savedatasaisieintemplate",
        //    datatemplate: this.dataTemplate,
        //    data_saisie: this.data
        //}, function (data) {
        //    Me.dataTemplate = data.lstdatatemplate[0]
        //    funcEnd(Me.dataTemplate)
        //})
        option.bddCtrl.mAjaxCall({
            command: "savecontactwithdatasaisie",
            datatemplate: this.dataTemplate,
            datasaisie: this.data
        }, function (data) {
            Me.dataTemplate = data.lstdatatemplate[0]
            funcEnd(Me.dataTemplate)
        }, null, funcKo)
    }

    this.mSaveInDocCptClient = function (dataDocCptClient) {
        dataDocCptClient.has_client = "1"
        dataDocCptClient.id_type_client = this.data.id_type_client
        dataDocCptClient.con_nom = this.data.con_nom
        dataDocCptClient.con_prenom = this.data.con_prenom
        dataDocCptClient.nom = this.data.nom_str
        dataDocCptClient.siret = this.data.siret
        dataDocCptClient.tva_intra = this.data.tvaintra
        dataDocCptClient.adresse_email = this.data.adresse_email
        dataDocCptClient.ad1 = this.data.adr_ad1
        dataDocCptClient.ad2 = this.data.adr_ad2
        dataDocCptClient.ad3 = this.data.adr_ad3
        dataDocCptClient.cp = this.data.adr_cp
        dataDocCptClient.ville = this.data.adr_ville
        dataDocCptClient.cedex = this.data.adr_cedex
        dataDocCptClient.pays = this.data.adr_pays
        dataDocCptClient.code_pays = this.data.adr_code_pays
        dataDocCptClient.adresse_email = this.data.adresse_email
        if (this.data.tel_sms && this.data.tel_sms.length > 0) {
            switch (parseInt(this.data.tel_num_type)) {
                case 0: case -1://fixe
                    dataDocCptClient.tel_sms = this.data.tel_sms
                    dataDocCptClient.tel_complet = this.data.tel_complet
                    dataDocCptClient.tel_error = this.data.tel_error
                    dataDocCptClient.tel_num_type = this.data.tel_num_type
                    dataDocCptClient.tel_number = this.data.tel_number
                    dataDocCptClient.tel_code_pays = this.data.tel_code_pays
                    break;
                case 1://mobile
                    dataDocCptClient.mob_sms = this.data.tel_sms
                    dataDocCptClient.mob_complet = this.data.tel_complet
                    dataDocCptClient.mob_error = this.data.tel_error
                    dataDocCptClient.mob_num_type = this.data.tel_num_type
                    dataDocCptClient.mob_number = this.data.tel_number
                    dataDocCptClient.mob_code_pays = this.data.tel_code_pays
                    break;
            }
        } else {
            dataDocCptClient.tel_sms = ""
            dataDocCptClient.tel_complet = ""
            dataDocCptClient.tel_error = null
            dataDocCptClient.tel_num_type = null
            dataDocCptClient.tel_number = ""
            dataDocCptClient.tel_code_pays = ""

            dataDocCptClient.mob_sms = ""
            dataDocCptClient.mob_complet = ""
            dataDocCptClient.mob_error = null
            dataDocCptClient.mob_num_type = null
            dataDocCptClient.mob_number = ""
            dataDocCptClient.mob_code_pays = ""
        }
    }

    this.mSaveInCompteClient = function (dataCompteClient) {
        dataCompteClient.has_client = "1"
        dataCompteClient.id_type_client = this.data.id_type_client
        dataCompteClient.nom_contact = this.data.con_nom
        dataCompteClient.prenom_contact = this.data.con_prenom
        dataCompteClient.nom = this.data.nom_str
        dataCompteClient.siret = this.data.siret
        dataCompteClient.tva_intra = this.data.tvaintra
        dataCompteClient.adresse_email = this.data.adresse_email
        dataCompteClient.ad1 = this.data.adr_ad1 +
            (this.data.adr_ad2 && this.data.adr_ad2.length > 0 ? ", " + this.data.adr_ad2 : "") +
            (this.data.adr_ad3 && this.data.adr_ad3.length > 0 ? ", " + this.data.adr_ad3 : "")
        dataCompteClient.cp = this.data.adr_cp
        dataCompteClient.ville = this.data.adr_ville
        dataCompteClient.pays = this.data.adr_pays
        dataCompteClient.code_pays = this.data.adr_code_pays
        dataCompteClient.adresse_email = this.data.adresse_email
        if (this.data.tel_sms && this.data.tel_sms.length > 0) {
            switch (parseInt(this.data.tel_num_type)) {
                case 0: case -1://fixe
                    dataCompteClient.tel_sms = this.data.tel_sms
                    dataCompteClient.tel_complet = this.data.tel_complet
                    dataCompteClient.tel_error = this.data.tel_error
                    dataCompteClient.tel_num_type = this.data.tel_num_type
                    dataCompteClient.tel_number = this.data.tel_number
                    dataCompteClient.tel_code_pays = this.data.tel_code_pays
                    break;
                case 1://mobile
                    dataCompteClient.mob_sms = this.data.tel_sms
                    dataCompteClient.mob_complet = this.data.tel_complet
                    dataCompteClient.mob_error = this.data.tel_error
                    dataCompteClient.mob_num_type = this.data.tel_num_type
                    dataCompteClient.mob_number = this.data.tel_number
                    dataCompteClient.mob_code_pays = this.data.tel_code_pays
                    break;
            }
        } else {
            dataCompteClient.tel_sms = ""
            dataCompteClient.tel_complet = ""
            dataCompteClient.tel_error = null
            dataCompteClient.tel_num_type = null
            dataCompteClient.tel_number = ""
            dataCompteClient.tel_code_pays = ""

            dataCompteClient.mob_sms = ""
            dataCompteClient.mob_complet = ""
            dataCompteClient.mob_error = null
            dataCompteClient.mob_num_type = null
            dataCompteClient.mob_number = ""
            dataCompteClient.mob_code_pays = ""
        }
    }

    this.mResumeForDataDocCptClient = function () {
        return this.data.con_nom + this.data.con_prenom + this.data.nom_str + this.data.siret + this.data.tvaintra + this.data.adresse_email + this.data.adr_ad1 + this.data.adr_ad2 + this.data.adr_ad3 + this.data.adr_cp + this.data.adr_ville + this.data.adr_cedex + this.data.adr_pays + this.data.tel_sms
    }

    this.mSaveInDataSaisie = function () {
        option.bddCtrl.mAjaxCall({
            command: "savedatasaisiesimple",
            datatemplate: this.dataTemplate,
            data_saisie: this.data
        }, function (data) {
            Me.dataTemplate = data.lstdatatemplate[0]
            funcEnd(Me.dataTemplate)
        })
    }

    this.mIsCoordonneDifferenteWithTemplate = function (idTableInitial, idInitial) {
        if (!this.dataTemplate ||
            (idTableInitial != this.dataTemplate.id_table_destinataire ||
                idInitial != this.dataTemplate.id_destinataire) ||
            this.dataTemplate.adresse_email != this.data.adresse_email ||
            this.dataTemplate.con_nom != this.data.con_nom ||
            this.dataTemplate.con_prenom != this.data.con_prenom ||
            this.dataTemplate.adr_ad1 != this.data.adr_ad1 ||
            this.dataTemplate.adr_ad2 != this.data.adr_ad2 ||
            this.dataTemplate.adr_ad3 != this.data.adr_ad3 ||
            this.dataTemplate.adr_cp != this.data.adr_cp ||
            this.dataTemplate.adr_ville != this.data.adr_ville ||
            this.dataTemplate.adr_pays != this.data.adr_pays) {
            return true
        } else {
            if (this.data.tel_sms && this.data.tel_sms.length > 0) {
                switch (parseInt(this.data.tel_num_type)) {
                    case 0: case -1://fixe
                        if (this.data.tel_sms != this.dataTemplate.tel_sms) return true
                        break;
                    case 1://mobile
                        if (this.data.tel_sms != this.dataTemplate.mob_sms) return true
                        break;
                }
            }
            return false
        }
    }

}